import { Component, inject, input, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { produce } from 'immer';
import { TechnicalInfoComponent } from 'libs/guideline/feature-sidebar/src/lib/components/sub-components/technical-info/technical-info.component';
import { GuidelineService } from 'shared/domain';

import { ComponentWidget, GuidelineCriterionComponent } from '@treetop/shared/model';
import { GuidelineElementSection, GuidelineElementType } from '@treetop/shared/reference-numbering';

import { DividerComponent } from '../../../../../../../../shared/ui-common/src/lib/components/divider/divider.component';
import { TitleDescriptionComponent } from '../../../chapter-sidebar-wrapper/components/title-description/title-description.component';
import {
  GuidelineSidebarBasics,
  GuidelineSidebarBasicsComponent,
} from '../../../guideline-sidebar-basics/guideline-sidebar-basics.component';

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    TranslocoModule,
    MatOptionModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    MatTabsModule,
    TitleDescriptionComponent,
    TechnicalInfoComponent,
    GuidelineSidebarBasicsComponent,
    DividerComponent,
  ],
  selector: 'guideline-component-sidebar-criteria',
  templateUrl: './guideline-component-sidebar-criteria.component.html',
  styleUrls: ['./guideline-component-sidebar-criteria.component.scss'],
})
export class GuidelineComponentSidebarCriteriaComponent {
  private guidelineService = inject(GuidelineService);

  public widget = input<ComponentWidget<GuidelineCriterionComponent>>();

  protected showAllMedications = signal(false);

  public handleTitleChanged(title: string): void {
    const newWidget = produce(this.widget(), (draft) => {
      draft.component.title = title;
    });

    this.guidelineService.updateWidget(newWidget.uniqueId, newWidget);
  }

  protected handleBasicsChanged(basics: GuidelineSidebarBasics) {
    const newWidget = produce(this.widget(), (draft) => {
      draft.references = basics.references;
      draft.links = basics.links;
      draft.attachments = basics.attachments;
      draft.resourceTags = basics.resourceTags;
    });

    this.guidelineService.updateWidget(newWidget.uniqueId, newWidget);
  }

  protected readonly GuidelineElementSection = GuidelineElementSection;
  protected readonly GuidelineElementType = GuidelineElementType;
}
